<template>
	<div class="addfeebook" :style="{ height: `${windowHeight}px` }">
		<el-row>
			<el-col :span="2" class="collabel"><span>工 作 号</span></el-col>
			<el-col :span="4"><el-input size="mini" ref="p_pkval" v-model="feebook.p_pkval" @keyup.native="val => enterinput(val, 'crm_c_id', '')" @blur="GetFeeBookInfo('')"></el-input></el-col>
			<el-col :span="2" class="collabel" v-show="type == '1'"><span>客户名称</span></el-col>
			<el-col :span="4" v-show="type == '1'">
				<el-select
					ref="crm_c_id"
					v-model="feebook.crm_c_cname"
					filterable
					remote
					reserve-keyword
					size="mini"
					placeholder="请输入关键词"
					:remote-method="customerinput"
					@keyup.native="val => enterinput(val, 'p_airwaybill', 'p_pkval')"
					@change="handleSelect"
					:loading="loading"
				>
					<el-option v-for="item in customerlist" :key="item.cname" :label="item.cname" :value="item.cname"></el-option>
				</el-select>
			</el-col>
			<el-col :span="2" class="collabel"><span>业 务 员</span></el-col>
			<el-col :span="4">
				<el-input v-if="type == '1'" size="mini" ref="u_account_sales" v-model="feebook.u_account_sales" :readonly="true"></el-input>
				<el-autocomplete
				    v-if="type == '0'"
					ref="u_account_sales"
					:trigger-on-focus="false"
					v-model="feebook.u_account_sales"
					:fetch-suggestions="searchuser"
					value-key="u_account"
					size="mini"
					style="width:98%"
					@keyup.native="val => enterinput(val, 'p_airwaybill', 'p_pkval')"
				>
					<template slot-scope="{ item }">
						<div>{{ item.u_account }} ( {{ item.u_name }} )</div>
					</template>
				</el-autocomplete>
			</el-col>
			<el-col :span="2" class="collabel"><span>提 单 号</span></el-col>
			<el-col :span="4" style="padding-right:10px">
				<el-input size="mini" ref="p_airwaybill" v-model="feebook.p_airwaybill" @keyup.native="val => enterinput(val, 'expresscode', 'crm_c_id')"></el-input>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="2" class="collabel"><span>快递公司</span></el-col>
			<el-col :span="4">
				 <el-select size="mini" ref="expresscode" v-model="feebook.expresscode" filterable @keyup.native="val => enterinput(val, 'expressid', 'p_airwaybill')">
				    <el-option
				      v-for="item in expresslist"
				      :key="item.value"
				      :label="item.label"
				      :value="item.value">
				    </el-option>
				  </el-select>
			</el-col>
			<el-col :span="2" class="collabel"><span>快递单号</span></el-col>
			<el-col :span="4">
				<el-input size="mini" ref="expressid" v-model="feebook.expressid" @keyup.native="val => enterinput(val, 'p_pkval_link1', 'expresscode')"></el-input>
			</el-col>
			<el-col :span="2" class="collabel"><span>关联单号1</span></el-col>
			<el-col :span="4">
				<el-input size="mini" ref="p_pkval_link1" v-model="feebook.p_pkval_link1" @keyup.native="val => enterinput(val, 'p_pkval_link2', 'expressid')"></el-input>
			</el-col>
			<el-col :span="2" class="collabel"><span>关联单号2</span></el-col>
			<el-col :span="4" style="padding-right:10px">
				<el-input size="mini" ref="p_pkval_link2" v-model="feebook.p_pkval_link2" @keyup.native="val => enterinput(val, 'p_pkval_link3', 'p_pkval_link1')"></el-input>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="2" class="collabel"><span>关联单号3</span></el-col>
			<el-col :span="4">
				<el-input size="mini" ref="p_pkval_link3" v-model="feebook.p_pkval_link3" @keyup.native="val => enterinput(val, 'tablegrid', 'p_pkval_link2')"></el-input>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24" style="padding-left:15px">
				<tableui
					style="width:99%;"
					ref="tablegridfeebook"
					v-loading="loading"
					:tableData="limitlist"
					:columns="limitcol"
					:gridheight="gridheight"
					editcell="1"
					:stripe="false"
					@gridhandle="feebookhandle"
					@autoaddrow="feebookhandle"
					@setuparrow="setuparrow"
					@selectFilter="selectFilter"
				></tableui>
			</el-col>
		</el-row>
		<el-row class="footerhandler" v-if="!btndisabled">
			<el-col :span="5" style="color:transparent;">1</el-col>
			<el-col :span="4" class="submitBtn"><div @click="savefeebook" ref="save">保存</div></el-col>
			<el-col :span="4" class="submitBtn_cancel"><div @click="reback" ref="reback">返回</div></el-col>
		</el-row>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import tableui from '@/components/table/tablegrid.vue';
export default {
	components: {
		tableui
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			btndisabled: false,
			windowHeight: window.innerHeight - 120,
			gridheight: window.innerHeight - 300 + 'px',
			type: '', // 1-收入单 0-支出单
			customerlist: [],
			feebook: {
				crm_c_id: '', //客户编号
				crm_c_cname: '', //客户名称
				u_account_sales: '',
				p_pkval: '',
				p_airwaybill: '',
				expressid: '',
				expresscode:'',
				p_pkval_link1: '',
				p_pkval_link2: '',
				p_pkval_link3: ''
			},
			loading: false,
			limitcol: [
				{ field: 'p_type', title: '收费项目', type: 'select_filter', width: '120', source: [], oldsource: []},
				{ field: 'p_paytype', title: '收费方式', type: 'select_filter', width: '120', source: [], oldsource: []},
				{ field: 'amount', title: '金额', type: 'input', width: '80'},
				{ field: 'u_createtime', title: '操作时间', type: 'time', width: '120'},
				{ field: 'remark', title: '备注', type: 'input', width: '200'},
				{
					field: '',
					title: '操作',
					type: 'template',
					width: '120',
					template: [
						{ type: 'link', title: '添加', icon: '', handletype: 'success', event: 'addrow' },
						{ type: 'link', title: '删除', icon: '', handletype: 'danger', event: 'delrow' }
					]
				}
			],
			limitlist: [],
			limitrow: {
				p_type: '',
				p_paytype: '',
				amount: '',
				u_createtime: '',
				remark: '',
				remark1: ''
			},
			expresslist:[],
			divclass: 'addfeebook'
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/cw/feebook.scss');
		});
		//console.log('this.urlparam', this.urlparam);
		if (this.urlparam != undefined) {
			if (this.urlparam.type != undefined) this.type = this.urlparam.type;
			if(this.urlparam.pkval!=undefined) this.feebook.p_pkval=this.urlparam.pkval;
		}
		this.init();
	},
	methods: {
		init() {
			this.limitrow.u_createtime = this.$tool.formatdate();
			var that = this;
			setTimeout(function() {
				that.$refs['p_pkval'].focus();
			}, 200);
			if (this.type == '0') this.limitcol.splice(2, 0, { field: 'remark1', title: '供应商', type: 'select_filter', width: '120', source: [], oldsource: [],colshow:'1' });
			this.getFeeItem();
			this.GetFeeBookInfo('');
		},
		//获取收费项目
		getFeeItem() {
			var that = this;
			this.$apipost.get.dic({ type: '收费项目' }).then(res => {
				var feeitem = res.list;
				//设置列数据源
				var index = -1;
				for (var i = 0; i < that.limitcol.length; i++) {
					if (that.limitcol[i].field == 'p_type') {
						index = i;
						break;
					}
				}
				if (index > -1) {
					that.limitcol[index].source = JSON.parse(JSON.stringify(feeitem));
					that.limitcol[index].oldsource = JSON.parse(JSON.stringify(feeitem));
				}
			});
			this.$apipost.get.dic({ type: '支付方式' }).then(res => {
				var payitem = res.list;
				payitem.splice(0, 1);
				//设置列数据源
				var index = -1;
				for (var i = 0; i < that.limitcol.length; i++) {
					if (that.limitcol[i].field == 'p_paytype') {
						index = i;
						break;
					}
				}
				if (index > -1) {
					that.limitcol[index].source = JSON.parse(JSON.stringify(payitem));
					that.limitcol[index].oldsource = JSON.parse(JSON.stringify(payitem));
				}
			});
			if (that.limitlist.length == 0) that.limitlist.push(JSON.parse(JSON.stringify(that.limitrow)));
		},
		//选择客户联动
		customerinput(val) {
			var that = this;
			var search = {
				searchbox: val,
				c_type: '客户,客户及供应商'
			};
			this.$tool.customerlink(this, search, 'page');
		},
		//下拉筛选
		selectFilter(e) {
			if (e.col.title == '供应商') {
				var search = {
					searchbox: e.val,
					c_type: '供应商,客户及供应商'
				};
				this.$tool.customerlink(this, search, 'grid', e.col);
			}
		},
		//文本框回车
		enterinput(event, colnext, colperv) {
			if (event.keyCode != undefined) {
				if (event.keyCode == 13 || event.keyCode == 39) {
					if (colnext != '') {
						if (colnext == 'tablegrid') this.$refs.tablegridfeebook.setgridfoucs();
						else if (colnext == 'crm_c_id')
							//获取订单信息
							this.GetFeeBookInfo(colnext);
						else this.$refs[colnext].focus();
					}
				} else if (event.keyCode == 37) {
					if (colperv != '') this.$refs[colperv].focus();
				}
			}
		},
		//获取订单详情
		GetFeeBookInfo(colnext) {
			var that = this;
			if (this.feebook.p_pkval != '') {
				var paraminfo = {
					p_pkval: this.feebook.p_pkval,
					type: this.type,
					userid: localStorage.getItem('userid')
				};
				this.$tool.loading('正在读取订单', this.divclass);
				//console.log('uoqu账簿',JSON.stringify(paraminfo));
				this.$apipost.get.GetFeeBookInfo({ paraminfo: paraminfo }).then(res => {
					this.$tool.loadingclose();
					if (res.state == '0') {
						that.feebook.p_pkval = '';
						this.$refs['p_pkval'].focus();
						this.$tool.message(res.message, 0);
					} else {
						if (that.type == '1') {
							if(colnext!=''){
								this.$refs[colnext].focus();
							}
						} else {
							this.$refs['u_account_sales'].focus();
						}

						if (res.feebookinfo != '' && res.feebookinfo != undefined) {
							that.feebook = res.feebookinfo;
						} else {
							var pkval = that.feebook.p_pkval;
							that.feebook = {
								crm_c_id: '', //客户编号
								crm_c_cname: '', //客户名称
								p_pkval: pkval,
								u_account_sales: '',
								p_airwaybill: '',
								expressid: '',
								expresscode:'',
								p_pkval_link1: '',
								p_pkval_link2: '',
								p_pkval_link3: ''
							};
						}
						that.limitlist = [];
						if (res.limitlist != undefined) {
							if (res.limitlist.length > 0) {
								that.limitlist = res.limitlist;
							}
						}
						if (that.limitlist.length == 0) that.limitlist.push(JSON.parse(JSON.stringify(that.limitrow)));
					}
				});
			}
		},
		//选中提示选项时
		handleSelect(item) {
			var list = this.customerlist.filter(e => {
				return e.cname == item;
			});
			if (list.length > 0) {
				this.feebook.u_account_sales = list[0].u_account;
				this.feebook.crm_c_id = list[0].id;
			}
		},
		//保存账单信息
		savefeebook() {
			var that = this;
			var isgo = true;
			if (this.feebook.p_pkval == '') {
				this.$tool.message('请填写工作号', 0);
				isgo = false;
			}
			if (this.type == '1') {
				if (this.feebook.crm_c_cname == '') {
					this.$tool.message('请填写客户名称', 0);
					isgo = false;
				}
			}
			if(this.type=='0'){
				if (this.feebook.u_account_sales == '') {
					this.$tool.message('请填写业务员', 0);
					isgo = false;
				}
			}
			if (isgo) {
				for (var i = 0; i < this.limitlist.length; i++) {
					if (this.limitlist[i].p_type == '' && this.limitlist[i].p_paytype == '' && (this.limitlist[i].amount == '' || this.limitlist[i].amount == '0')) {
						if (i == 0) {
							this.$tool.message('请填写费用明细', 0);
							isgo = false;
							break;
						} else this.limitlist.splice(i, 1);
					} else {
						if (this.limitlist[i].p_type == '') {
							this.$tool.message('请填写第' + (i + 1) + '行的收费项目', 0);
							isgo = false;
							break;
						}
						if (this.limitlist[i].p_paytype == '') {
							this.$tool.message('请填写第' + (i + 1) + '行的收费方式', 0);
							isgo = false;
							break;
						}
						if (this.limitlist[i].amount == '' || this.limitlist[i].amount == '0') {
							this.$tool.message('请填写第' + (i + 1) + '行的金额', 0);
							isgo = false;
							break;
						}
						if (this.type == '1') {
							if (this.limitlist[i].c_type == '') {
								this.$tool.message('请填写第' + (i + 1) + '行的供应商', 0);
								isgo = false;
								break;
							}
						}
					}
				}
			}
			if (isgo) {
				this.$tool.loading('正在保存', this.divclass);
				this.btndisabled = true;
				var paraminfo = {
					feebook: this.feebook,
					limitlist: this.limitlist,
					type: this.type,
					userid: localStorage.getItem('userid'),
					u_name: localStorage.getItem('u_name'),
					u_account: localStorage.getItem('u_account'),
					u_company: localStorage.getItem('u_company')
				};
				//console.log('保存',JSON.stringify(paraminfo));
				//return false;
				this.$apipost.post.SaveFeeBook({ paraminfo: paraminfo }).then(res => {
					this.$tool.loadingclose();
					that.btndisabled = false;
					if (res.state == '1') {
						this.$tool.message('保存成功', 1);
						setTimeout(function() {
							that.reback();
						}, 1500);
					} else {
						this.$tool.message(res.message, 0);
					}
				});
			}
		},
		//返回
		reback() {
			Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		},
		//列表操作事件
		feebookhandle(e) {
			if (e.event == 'addrow') {
				this.limitlist.splice(e.index + 1, 0, JSON.parse(JSON.stringify(this.limitrow)));
			}
			if (e.event == 'delrow') {
				this.deleteRow(e);
			}
		},
		//删除行
		deleteRow(e) {
			this.limitlist.splice(e.index, 1);
			if (this.limitlist.length < 1) {
				this.limitlist.push(JSON.parse(JSON.stringify(this.limitrow)));
			}
		},
		setuparrow() {
			this.enterinput({ keyCode: 37 }, '', 'p_pkval_link3');
		},
		searchuser(val, cb) {
			var that = this;
			var search = new Object();
			if (this.u_account != '') {
				search.searchbox = this.feebook.u_account_sales;
			}
			setTimeout(function() {
				if (val != '') {
					//获取会员卡列表
					var paraminfo = {
						mode: '用户列表',
						tab: '',
						search: JSON.stringify(search),
						pageindex: 0,
						pagesize: 20,
						sort: '',
						iscount: 0,
						showcol: ''
					};
					that.$apipost.get.GetGridTable({ paraminfo: paraminfo }).then(res => {
						if(res.data.length>0)
							cb(res.data);
						else
							that.feebook.u_account_sales='';
					});
				}
			}, 300);
		}
	}
};
</script>
